import SongDetails from './SongDetails';
import PlayControls from './PlayControls';
import ExtraControlButtons from './ExtraButtons';
import NowPlayingBarMobile from './mobilePlayer';
import { MobileMenu } from './mobileMenu';
import { OtherDeviceAlert } from './otherDevice';

const NowPlayingBar = () => {
  return (
    <>
      <div>
        <div className='w-full bg-black flex items-center h-full mobile-hidden' style={{ padding: '6px 16px 16px 16px' }}>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start', minWidth: 0 }}>
            <SongDetails />
          </div>
          <PlayControls />
          <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', minWidth: 0 }}>
            <ExtraControlButtons />
          </div>
        </div>

        <OtherDeviceAlert />
      </div>

      <div className='mobile-bar'>
        <NowPlayingBarMobile />
        <MobileMenu />
      </div>
    </>
  );
};

export default NowPlayingBar;
